import { useEffect, useState } from "react";
import { LoginForm } from "../components/Auth/LoginForm";
import { Navbar } from "../components/Navbar";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import { useSearchParams, useLocation } from "react-router-dom";
import { RegisterForm } from "../components/Auth/RegisterForm";
import { CheckCircle } from "lucide-react";

const Auth = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const queryMode = searchParams.get("mode"); // read from URL
  const [mode, setMode] = useState(queryMode === "register" ? "register" : "login");

  // Get success message from navigation state
  const successMessage = location.state?.message;
  const messageType = location.state?.type;

  // Sync tab state when URL query param changes
  useEffect(() => {
    if (queryMode && queryMode !== mode) {
      setMode(queryMode);
    }
  }, [queryMode, mode]);

  // Clear the state message after showing it
  useEffect(() => {
    if (location.state?.message) {
      // Clear the state after 5 seconds
      const timer = setTimeout(() => {
        window.history.replaceState({}, document.title);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  const handleTabChange = (newMode) => {
    setMode(newMode);
    setSearchParams({ mode: newMode }); // updates URL without reloading
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="flex-1 pt-24 pb-16 flex items-center justify-center">
        <div className="container px-4 mx-auto">
          <div className="max-w-md mx-auto">
            <div className="text-center mb-8 animate-fade-in">
              <h1 className="text-3xl font-bold mb-2">{mode === 'login' ? 'Welcome Back' : 'Create Your Account'}</h1>
              <p className="text-muted-foreground">
                {mode === "login"
                  ? "Sign in to access your Igbanwo account"
                  : "Join our community of bartering enthusiasts"}
              </p>
            </div>

            {/* Success Message Display */}
            {successMessage && messageType === 'success' && (
              <div className="flex items-center gap-2 p-3 text-sm text-green-600 bg-green-50 border border-green-200 rounded-md mb-6 animate-fade-in">
                <CheckCircle size={16} className="flex-shrink-0" />
                <span>{successMessage}</span>
              </div>
            )}

            <Tabs value={mode} onValueChange={handleTabChange} className="animate-fade-in">
              <TabsList className="grid w-full grid-cols-2 mb-8" >
                <TabsTrigger value="login">Sign In</TabsTrigger>
                <TabsTrigger value="register">Register</TabsTrigger>
              </TabsList>

              <TabsContent value="login">
                <LoginForm />
              </TabsContent>

              <TabsContent value="register">
                <RegisterForm />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Auth;